import { createTermTagManager } from '../../utils/createTermTagManager';

export const identicalOffersIdTagManager = createTermTagManager({
  jsonQueryKey: 'identical_id',
  template: 'Мультиобъявление №%s',
  id: 'identicalOffersId',
});
